module.exports = __webpack_public_path__ + "img/02.c7c1b67d.png";